import Meta from 'src/components/meta/Meta';

const MediaEnquiriesMeta = () => <Meta
  title="Media Enquiries | BrickX"
  description="We're always looking for ways to spread the BrickX story. You can get in touch with any media enquiries by emailing media@brickx.com"
/>;

export default MediaEnquiriesMeta;
